import { Component, NgModule, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-get-started",
    templateUrl: "./get-started.component.html",
    styleUrls: ["./get-started.component.css"],
})
export class GetStartedComponent implements OnInit {
    vendor = new FormGroup({
        userName: new FormControl(null, Validators.required),
        password: new FormControl(null, [
            Validators.required,
            //Validators.minLength(8),
        ]),
    });

    responseData: any;
    isLoading: boolean = false;
    isError: boolean = false;
    isServerError: boolean = false;
    token: any;

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService,
        private route: ActivatedRoute
    ) {
        this.route.queryParams.subscribe((params) => {
            if (params["token"]) {
                this.token = params["token"];
                //console.log(pathSplit);
            } else {
                this.router.navigateByUrl("/");
            }
        });
    }

    saveToken(
        session: any,
        name: any,
        vendor: any,
        nonPo_flag: any,
        logistics_flag: any
    ) {
        localStorage.setItem("userSession", session);
        localStorage.setItem("displayName", name);
        localStorage.setItem("vendorCode", vendor);
        localStorage.setItem("logisticFlag", logistics_flag);
        localStorage.setItem("nonPoFlag", nonPo_flag);
    }

    onValidateVendor() {
        this.isLoading = true;
        const req = {
            userName: this.vendor.value.userName.replaceAll(/\s/g, ""),
            password: this.vendor.value.password,
            token: this.token,
        };

        this.authService.signIn(req).subscribe(
            (res) => {
                this.responseData = res;
                this.isLoading = false;
                if (this.responseData.status == "success") {
                    const vendorCode =
                        this.responseData.response.user.sellerCode;
                    const userSession =
                        this.responseData.response.session.sessionId;
                    const displayName =
                        this.responseData.response.user.displayName;
                    const nonPoFlag =
                        this.responseData.response.user.non_po_flag;
                    const logisticFlag =
                        this.responseData.response.user.logistics_flag;
                    this.saveToken(
                        userSession,
                        displayName,
                        vendorCode,
                        nonPoFlag,
                        logisticFlag
                    );
                    if (
                        this.responseData.response.user.hasOnboarded === false
                    ) {
                        this.router.navigateByUrl("/vendor-master-data");
                    } else {
                        this.router.navigateByUrl("/dashboard");
                    }
                } else {
                    if (
                        this.responseData.message ===
                            "Invalid credentials or user not active" ||
                        this.responseData.message ===
                            "Invalid username or password"
                    ) {
                        this.isError = true;
                    } else {
                        this.isServerError = true;
                    }
                }
            },
            (error) => {
                this.isServerError = true;
                this.isLoading = false;
            }
        );
    }

    ngOnInit(): void {}
}
